import { Table, Row, Col } from "antd";
import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import FixtureWrapper from "./Fixtures";

import {
  MATCHES,
  load,
  unload,
  isLoading,
  showQaulify
} from "../../../../../../Store/Features/MatchesSlice";
import { error } from "../../../../../../common/Alerts/Message";
import Loader from "../../../../../../common/cards/Loader";
import { GetGroupEventData } from "../../../../../../Config/API/events";
import { MultiplayerScheduleGetData } from "../../../../../../Config/API/multiplayerSchedule";
import { QualifyingColumn, Column } from "../../cards/columns";
import { useSortedpoints } from "../utility";
import useRoundsButtons from "../KO/useRoundsUtility/useRoundsButtons";
import { GAMES_MODES } from "../../../../../../Config/helpers/constants";

const Matches = () => {
  const Matches = useSelector(MATCHES);
  let showq = useSelector(showQaulify);
  const loading = useSelector(isLoading);
  const dispatch = useDispatch();
  const { state } = useLocation();
  const { id } = useParams();

  const pagesise = 8;

  const navigate = useNavigate();
  const { sorteddata } = useSortedpoints();

  var columns = [];
  if (showq) {
    columns = QualifyingColumn;
  } else columns = Column;

  const get = async () => {
    try {
      if (state?.typeofmatch === GAMES_MODES.multi) {
        const res = await MultiplayerScheduleGetData({
          eventId: state?._id || id
        });
        const data = await res.json();

        console.log(data);
      } else {
        const res = await GetGroupEventData({ eventId: state?._id || id });
        const data = await res.json();

        console.log(data);

        await sorteddata(data?.result[0]);

        if (data?.result[0]?.complete) {
          navigate(`/organizer/event/${id}/knock-out-matches`, {
            replace: true,
            state
          });
        }
      }
      dispatch(unload());
    } catch (e) {
      console.log(e);
      error(e.message);
      dispatch(unload());
    }
  };

  useEffect(() => {
    dispatch(load());
    get();
  }, []);

  const { HistoryButtons } = useRoundsButtons();
  return (
    <div>
      <h1 className="ceheading">Matches</h1>
      <HistoryButtons origin={"groupstages"} loading={loading} />
      <div
        className={`formorganizer ${loading ? "rowloadingevent" : null}`}
        style={{
          marginBottom: "50px",
          paddingBottom: "0"
        }}>
        {loading ? <Loader noShadow /> : null}
        <Row justify="center" style={{ display: loading ? "none" : undefined }}>
          <Col xl={16} lg={24} xs={24} sm={24} md={24} className="ceinputformpadding">
            <h2
              style={{
                borderBottom: "1px solid  #282828",
                paddingBottom: "5px"
              }}>
              Standings
            </h2>
            {Matches?.teams?.map((e, i) => (
              <Table
                title={() => <div className="tableTitle" key={i}>{`Group ${i + 1}`}</div>}
                key={i}
                scroll={{ x: 400 }}
                style={{
                  paddingTop: e?.length < pagesise ? "20px" : "30px",
                  paddingBottom: e?.length < pagesise ? "50px" : null
                }}
                columns={columns}
                dataSource={e}
                size="middle"
                pagination={{
                  total: e?.length,
                  defaultCurrent: 1,
                  defaultPageSize: pagesise,
                  hideOnSinglePage: true,
                  style: { margin: "50px 0 10px auto" }
                }}
                className="tablesBoxShadow scrollAble"
              />
            ))}
          </Col>
        </Row>
        {loading || state?.typeofmatch === GAMES_MODES.multi ? null : (
          <FixtureWrapper sortedpoints={sorteddata} />
        )}
      </div>
    </div>
  );
};

export default Matches;
